<template>
  <div class="quote-overview-header__body">
    <div class="row container">
      <div>
        <new-configuration />
      </div>

      <div>
        <div class="button-wrapper">
          <app-button
            button-class="button primary large"
            data-qa="open-configurator-button"
            @click="openConfigurator"
          >
            <icon icon="configurator" />
            {{ i18n.t('/Dashboard/ConfiguratorButtonText') }}
            <icon icon="angle-right" />
          </app-button>
          <app-button
            v-if="isDealerConfiguratorButtonVisible"
            button-class="button primary large"
            data-qa="open-dealer-configurator-button"
            @click="openDealerConfigurator"
          >
            <icon icon="configurator" />
            {{ i18n.t('/Dashboard/DealerConfiguratorButtonText') }}
            <icon icon="angle-right" />
          </app-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewConfiguration from '@/components/generic/presentational/molecules/newConfiguration/NewConfiguration.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'

export default {
  components: {
    NewConfiguration,
    AppButton,
    Icon,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    configuratorUrl() {
      return this.i18n.t('/Configuration/ConfiguratorUrl', {
        returnUrl: this.returnUrl,
      })
    },
    isDealerConfiguratorButtonVisible() {
      return this.i18n.translationExists('/Configuration/DealerConfiguratorUrl')
    },
    dealerConfiguratorUrl() {
      return this.i18n.t('/Configuration/DealerConfiguratorUrl', {
        returnUrl: this.returnUrl,
      })
    },
    returnUrl() {
      const relativeUrl = this.$router.resolve({
        name: `configurator-callback`,
        ...this.$route.params,
      }).href

      return encodeURIComponent(`${window.location.origin}${relativeUrl}`)
    },
  },
  methods: {
    openConfigurator() {
      this.openLink(this.configuratorUrl)
    },
    openDealerConfigurator() {
      this.openLink(this.dealerConfiguratorUrl)
    },
    openLink(url) {
      if (this.i18n.t('/Configuration/ConfiguratorUrlTarget') == '_blank') {
        window.open(url)
      } else {
        location.href = url
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.quote-overview-header__body {
  display: flex;
  justify-content: space-around;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  background: #f1f4f5;
}

.container {
  @include center;
  display: grid;
  row-gap: 20px;
}

.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;

  > div {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 1;
  }
}

.button-wrapper {
  padding-left: 10px;
  align-self: flex-end;
  display: flex;
  flex-direction: row;

  button {
    display: flex;
  }
}
</style>
